import {GraphQLQuery} from '@aws-amplify/api';
import {notifyError} from "../../../../components/ServiceNotifications";
import {ListPricesResponse, Price} from '../types';
import {listPricesByProduct} from './queries';
import {billingClient} from '../../billing-api-integration/client';

export const fetchPricesByProduct = async (productId: string): Promise<Price[]> => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<ListPricesResponse>>({
                                                                     query: listPricesByProduct,
                                                                     variables: {
                                                                         productId,
                                                                         filter: {
                                                                             priceStatus: 'Active'
                                                                         }
                                                                     },
                                                                 });
        return response.data?.listPrices?.items || [];
    } catch (e) {
        console.error('Error fetching prices:', e);
        notifyError(e);
        return [];
    }
};


